var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Webcam from 'react-webcam';
import { DialogPosition } from '../../models';
import { imageResize, renderIcon } from '../../utils';
import { Dialog } from '../dialog/dialog';
import { PictureIcon, FlipArrowIcon } from './icons';
export var Camera = function (_a) {
    var onGetPhoto = _a.onGetPhoto, onClose = _a.onClose, resolutionLimit = _a.resolutionLimit;
    var _b = useState({ exact: 'environment' }), facingMode = _b[0], setFacingMode = _b[1];
    var _c = useState(false), isAllowedSwitchCamera = _c[0], setIsAllowedSwitchCamera = _c[1];
    var _d = useState(''), preview = _d[0], setPreview = _d[1];
    var videoConstraints = {
        width: 480,
        height: 720,
        aspectRatio: 0.67,
        facingMode: facingMode,
    };
    var onSwitchCamera = function () {
        setFacingMode(function (prevState) {
            return prevState === 'user' ? { exact: 'environment' } : 'user';
        });
    };
    var handleImageUpload = function (event) {
        var target = event.target;
        var file = target.files[0];
        var reader = new FileReader();
        reader.addEventListener('load', function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, resizedImage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = String(reader.result);
                        return [4, imageResize(data, resolutionLimit === undefined ? null : resolutionLimit, null, null)];
                    case 1:
                        resizedImage = _a.sent();
                        onGetPhoto(resizedImage);
                        onClose();
                        return [2];
                }
            });
        }); }, false);
        reader.readAsDataURL(file);
    };
    var onClear = function () {
        setPreview('');
    };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resizedPreview;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, imageResize(String(preview), resolutionLimit === undefined ? null : resolutionLimit, null, null)];
                case 1:
                    resizedPreview = _a.sent();
                    onGetPhoto(String(resizedPreview));
                    onClose();
                    return [2];
            }
        });
    }); };
    useEffect(function () {
        var _a;
        var gotDevices = function (mediaDevices) {
            var availableVideoInputs = [];
            mediaDevices.forEach(function (mediaDevice) {
                if (mediaDevice.kind === 'videoinput') {
                    availableVideoInputs.push({
                        deviceId: mediaDevice.deviceId,
                        label: mediaDevice.label,
                    });
                }
            });
            if (availableVideoInputs.length > 1) {
                setIsAllowedSwitchCamera(true);
            }
            else {
                setIsAllowedSwitchCamera(false);
            }
        };
        (_a = navigator === null || navigator === void 0 ? void 0 : navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.enumerateDevices().then(gotDevices);
    }, []);
    return (_jsx(Dialog, __assign({ fullScreen: true, visible: true, position: DialogPosition.Top }, { children: _jsxs("div", __assign({ className: "relative flex h-full w-full flex-col items-center justify-evenly\tbg-black" }, { children: [_jsx("button", __assign({ className: 'absolute top-0 ml-6 mt-8 self-start', onClick: onClose }, { children: renderIcon('XIcon', 'w-6 h-6 text-white hover:text-uiLight') })), preview ? (_jsx("div", __assign({ className: "mt-10 grid content-center", style: { height: '70%', marginTop: 40 } }, { children: _jsx("img", { alt: "preview", src: String(preview) }) }))) : (_jsx(Webcam, __assign({ className: "mt-10", audio: false, screenshotFormat: "image/jpeg", videoConstraints: videoConstraints }, { children: function (_a) {
                        var getScreenshot = _a.getScreenshot;
                        return (_jsxs("div", __assign({ className: "flex w-full items-center justify-evenly" }, { children: [_jsx("input", { id: "actual-btn", type: "file", onChange: handleImageUpload, accept: "image/*", hidden: true }), _jsxs("label", __assign({ htmlFor: "actual-btn", className: "relative flex items-center" }, { children: [_jsx("span", { className: "z-1 absolute h-8 w-10 rounded-md bg-white" }), _jsx(PictureIcon, {})] })), _jsx("button", { onClick: function () {
                                        var imageSrc = getScreenshot();
                                        setPreview(imageSrc);
                                    }, className: "h-24 w-24 rounded-full border-8 bg-white" }), _jsx("button", __assign({ className: "flex h-10 w-10 items-center justify-center rounded-xl bg-white", onClick: onSwitchCamera }, { children: _jsx(FlipArrowIcon, {}) }))] })));
                    } }))), preview && (_jsxs("div", __assign({ className: "flex w-full justify-between px-6" }, { children: [_jsx("button", __assign({ className: "h-14 w-14", onClick: onClear }, { children: renderIcon('XCircleIcon', 'h-full w-full text-uiBg') })), _jsx("button", __assign({ className: "h-14 w-14", onClick: onSubmit }, { children: renderIcon('CheckCircleIcon', 'h-full w-full text-successMain') }))] })))] })) })));
};
//# sourceMappingURL=index.js.map